/* Imports */
import React from "react"
import { Grid } from "fajny-react"
import { v4 as uuid } from "uuid"

import ComponentPage from "../../components/ComponentPage"
import ColumnCard from "../../components/ColumnCard"

import allShadows from "../../data/all-shadows"

const ShadowsPage = () => {
    return (
        <ComponentPage>
            <Grid gap="s" col={2}>
                {allShadows.map(shadow => (
                    <ColumnCard item={shadow} shadow key={uuid()} />
                ))}
            </Grid>
        </ComponentPage>
    )
}

export default ShadowsPage
